// Some documentation:
// https://github.com/wix-private/santa-editor/wiki/Resize-gaps-functionality

import { createEntryPoint } from '#packages/apilib';
import { ResizeGapsScope } from './resizeGapsScope';
import { ResizeGapsApi } from './resizeGapsApi';
import { ResizeGapsApiKey } from './publicApiKey';

import GapBox from './components/gapBox';

export const ResizeGapsEntryPoint = createEntryPoint({
  name: 'ResizeGaps',
  Scope: ResizeGapsScope,
  publicApi({ contributeApi }) {
    contributeApi(ResizeGapsApiKey, ResizeGapsApi);
  },
  async initialize(scope: ResizeGapsScope) {
    const { workspace } = scope;

    workspace.contributeMouseCatcherComponent(GapBox);
  },
});
